import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import { store } from "./Redux/store";
import { Toaster } from "react-hot-toast";
import { GoogleOAuthProvider } from "@react-oauth/google";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { jwtDecode } from "jwt-decode";
import { logout } from "./Redux/slices/authSlice";
import ErrorBoundary from "./Components/ErrorBoundary";
import { clearLocalCreatorPushSubscription } from "./Utils/pushNotificationLocal";

const token = localStorage.getItem("auth-access");

if (token) {
  try {
    const decodedToken: { exp: number } = jwtDecode(token);
    if (decodedToken.exp * 1000 < Date.now()) {
      void clearLocalCreatorPushSubscription();
      store.dispatch(logout());
    }
  } catch (error) {
    void clearLocalCreatorPushSubscription();
    store.dispatch(logout());
  }
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const CLIENT_ID: string = process.env.REACT_APP_CLIENT_ID! || "";

root.render(
  <Provider store={store}>
    <Toaster />
    <GoogleOAuthProvider clientId={CLIENT_ID}>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </GoogleOAuthProvider>
  </Provider>
);

reportWebVitals();

serviceWorkerRegistration.reloadOnControllerChange();
serviceWorkerRegistration.register({
  onUpdate: serviceWorkerRegistration.applyUpdate,
});
